__turbopack_context__.v({
  "brand": "ButtonBottom-module-scss-module__KCTf7W__brand",
  "dark": "ButtonBottom-module-scss-module__KCTf7W__dark",
  "disabled": "ButtonBottom-module-scss-module__KCTf7W__disabled",
  "green": "ButtonBottom-module-scss-module__KCTf7W__green",
  "orange": "ButtonBottom-module-scss-module__KCTf7W__orange",
  "red": "ButtonBottom-module-scss-module__KCTf7W__red",
  "submitBtn": "ButtonBottom-module-scss-module__KCTf7W__submitBtn",
});
